import {SelectOptions} from 'forms/components/BasicSelect';
import {DataItem} from 'types/model/dataItems/DataItem';

export const getDataItemOptions = (dataItems: DataItem[]): SelectOptions<number> =>
    dataItems.map(x => ({label: x.name, value: x.id}));
